(() => {
  let attempts = 0;

  function visibleOrderTarget() {
    return [...document.querySelectorAll('.product-form')]
      .find((el) => {
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      }) || document.querySelector('product-info') || document.querySelector('.product__info-container');
  }

  function init(root) {
    if (!root || root.dataset.guardiaV2Ready === '1') return;

    const goToOrder = (event) => {
      event.preventDefault();
      const target = visibleOrderTarget();
      if (target) target.scrollIntoView({ behavior: 'auto', block: 'center' });
      updateSticky(root);
    };

    root.querySelectorAll('[data-guardia-buy]').forEach((el) => {
      el.addEventListener('click', goToOrder);
    });

    const more = root.querySelector('[data-review-more]');
    if (more) {
      more.addEventListener('click', () => {
        root.classList.toggle('wal-reviews-open');
        more.textContent = root.classList.contains('wal-reviews-open')
          ? 'Ver menos opiniones'
          : 'Ver más opiniones';
      });
    }

    const refresh = () => updateSticky(root);
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('pageshow', refresh);
    root.dataset.guardiaV2Ready = '1';
    refresh();
  }

  function updateSticky(root) {
    const sticky = root.querySelector('[data-guardia-sticky]');
    const orderTarget = visibleOrderTarget();
    if (!sticky || !orderTarget) return;
    const threshold = orderTarget.getBoundingClientRect().bottom + window.scrollY;
    sticky.classList.toggle('is-visible', window.scrollY > threshold);
  }

  function boot() {
    const roots = document.querySelectorAll('[id^="GuardiaLanding-"]');
    roots.forEach(init);
    attempts += 1;
    if ((!roots.length || !visibleOrderTarget()) && attempts < 20) {
      window.setTimeout(boot, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();
